import { getTitleEscrowAddress, encrypt, isTitleEscrowVersion, TitleEscrowInterface } from './../core';
import { v5Contracts } from './../token-registry-v5';
import { getTxOptions } from './utils';
import { getEthersContractFromProvider, isV6EthersProvider } from '../utils/ethers';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const rejectTransferHolder = /* @__PURE__ */ __name(async (contractOptions, signer, params, options) => {
  const { tokenRegistryAddress, tokenId } = contractOptions;
  let { titleEscrowAddress } = contractOptions;
  const { chainId, maxFeePerGas, maxPriorityFeePerGas, titleEscrowVersion } = options;
  if (!titleEscrowAddress) {
    if (!tokenRegistryAddress) throw new Error("Token registry address is required");
    if (!tokenId) throw new Error("Token ID is required");
    titleEscrowAddress = await getTitleEscrowAddress(
      tokenRegistryAddress,
      tokenId,
      signer.provider,
      {}
    );
  }
  if (!titleEscrowAddress) throw new Error("Title escrow address is required");
  if (!signer.provider) throw new Error("Provider is required");
  const { remarks } = params;
  const Contract = getEthersContractFromProvider(signer.provider);
  const titleEscrowContract = new Contract(
    titleEscrowAddress,
    v5Contracts.TitleEscrow__factory.abi,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    signer
  );
  const encryptedRemarks = remarks ? `0x${encrypt(remarks, options.id)}` : "0x";
  let isV5TT = titleEscrowVersion === "v5";
  if (titleEscrowVersion === void 0) {
    isV5TT = await isTitleEscrowVersion({
      titleEscrowAddress,
      versionInterface: TitleEscrowInterface.V5,
      provider: signer.provider
    });
  }
  if (!isV5TT) {
    throw new Error("Only Token Registry V5 is supported");
  }
  try {
    const isV6 = isV6EthersProvider(signer.provider);
    const args = isV5TT ? [encryptedRemarks] : [];
    if (isV6) {
      await titleEscrowContract.rejectTransferHolder.staticCall(...args);
    } else {
      await titleEscrowContract.callStatic.rejectTransferHolder(...args);
    }
  } catch (e) {
    console.error("callStatic failed:", e);
    throw new Error("Pre-check (callStatic) for rejectTransferHolder failed");
  }
  const txOptions = await getTxOptions(signer, chainId, maxFeePerGas, maxPriorityFeePerGas);
  return await titleEscrowContract.rejectTransferHolder(encryptedRemarks, txOptions);
}, "rejectTransferHolder");
const rejectTransferBeneficiary = /* @__PURE__ */ __name(async (contractOptions, signer, params, options) => {
  const { tokenRegistryAddress, tokenId } = contractOptions;
  let { titleEscrowAddress } = contractOptions;
  const { chainId, maxFeePerGas, maxPriorityFeePerGas, titleEscrowVersion } = options;
  if (!titleEscrowAddress) {
    if (!tokenRegistryAddress) throw new Error("Token registry address is required");
    if (!tokenId) throw new Error("Token ID is required");
    titleEscrowAddress = await getTitleEscrowAddress(
      tokenRegistryAddress,
      tokenId,
      signer.provider,
      {}
    );
  }
  if (!titleEscrowAddress) throw new Error("Token registry address is required");
  if (!signer.provider) throw new Error("Provider is required");
  const { remarks } = params;
  const Contract = getEthersContractFromProvider(signer.provider);
  const titleEscrowContract = new Contract(
    titleEscrowAddress,
    v5Contracts.TitleEscrow__factory.abi,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    signer
  );
  const encryptedRemarks = remarks ? `0x${encrypt(remarks, options.id)}` : "0x";
  let isV5TT = titleEscrowVersion === "v5";
  if (titleEscrowVersion === void 0) {
    isV5TT = await isTitleEscrowVersion({
      titleEscrowAddress,
      versionInterface: TitleEscrowInterface.V5,
      provider: signer.provider
    });
  }
  if (!isV5TT) {
    throw new Error("Only Token Registry V5 is supported");
  }
  try {
    const isV6 = isV6EthersProvider(signer.provider);
    const args = isV5TT ? [encryptedRemarks] : [];
    if (isV6) {
      await titleEscrowContract.rejectTransferBeneficiary.staticCall(...args);
    } else {
      await titleEscrowContract.callStatic.rejectTransferBeneficiary(...args);
    }
  } catch (e) {
    console.error("callStatic failed:", e);
    throw new Error("Pre-check (callStatic) for rejectTransferBeneficiary failed");
  }
  const txOptions = await getTxOptions(signer, chainId, maxFeePerGas, maxPriorityFeePerGas);
  return await titleEscrowContract.rejectTransferBeneficiary(encryptedRemarks, txOptions);
}, "rejectTransferBeneficiary");
const rejectTransferOwners = /* @__PURE__ */ __name(async (contractOptions, signer, params, options) => {
  const { tokenRegistryAddress, tokenId } = contractOptions;
  let { titleEscrowAddress } = contractOptions;
  const { chainId, maxFeePerGas, maxPriorityFeePerGas, titleEscrowVersion } = options;
  if (!titleEscrowAddress) {
    if (!tokenRegistryAddress) throw new Error("Token registry address is required");
    if (!tokenId) throw new Error("Token ID is required");
    titleEscrowAddress = await getTitleEscrowAddress(
      tokenRegistryAddress,
      tokenId,
      signer.provider,
      {}
    );
  }
  if (!titleEscrowAddress) throw new Error("Token registry address is required");
  if (!signer.provider) throw new Error("Provider is required");
  const { remarks } = params;
  const Contract = getEthersContractFromProvider(signer.provider);
  const titleEscrowContract = new Contract(
    titleEscrowAddress,
    v5Contracts.TitleEscrow__factory.abi,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    signer
  );
  const encryptedRemarks = remarks ? `0x${encrypt(remarks, options.id)}` : "0x";
  let isV5TT = titleEscrowVersion === "v5";
  if (titleEscrowVersion === void 0) {
    isV5TT = await isTitleEscrowVersion({
      titleEscrowAddress,
      versionInterface: TitleEscrowInterface.V5,
      provider: signer.provider
    });
  }
  if (!isV5TT) {
    throw new Error("Only Token Registry V5 is supported");
  }
  try {
    const isV6 = isV6EthersProvider(signer.provider);
    const args = isV5TT ? [encryptedRemarks] : [];
    if (isV6) {
      await titleEscrowContract.rejectTransferOwners.staticCall(...args);
    } else {
      await titleEscrowContract.callStatic.rejectTransferOwners(...args);
    }
  } catch (e) {
    console.error("callStatic failed:", e);
    throw new Error("Pre-check (callStatic) for rejectTransferOwners failed");
  }
  const txOptions = await getTxOptions(signer, chainId, maxFeePerGas, maxPriorityFeePerGas);
  return await titleEscrowContract.rejectTransferOwners(encryptedRemarks, txOptions);
}, "rejectTransferOwners");

export { rejectTransferBeneficiary, rejectTransferHolder, rejectTransferOwners };
